import script from "./TextCopy.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextCopy.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__